import { FormFieldWidget, ModelFieldType, SPI, ViewType, SearchDateTimeRangeFieldWidget } from '@kunlun/dependencies';
import EnhancedTimeDatePicker from './EnhancedTimeDatePicker.vue';
import { isNil } from 'lodash-es';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Search,
    ttype: ModelFieldType.DateTime,
    widget: 'EnhancedTimeDatePicker',
    multi: false
  })
)
export class SearchDatetimeEnhancedTimeDatePickerFieldWidget extends SearchDateTimeRangeFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(EnhancedTimeDatePicker);
    return this;
  }

  protected mountedProcess() {
    if (this.config.defaultThisMonth && isNil(this.formData[this.itemData])) {
      const firstDate = new Date();
      firstDate.setDate(1);
      const endDate = new Date(firstDate);
      endDate.setMonth(firstDate.getMonth() + 1);
      endDate.setDate(0);

      const sYear = firstDate.getFullYear().toString();
      const sMonth = (firstDate.getMonth() + 1).toString().padStart(2, '0');
      const sDay = firstDate.getDate().toString().padStart(2, '0');

      const eYear = endDate.getFullYear().toString();
      const eMonth = (endDate.getMonth() + 1).toString().padStart(2, '0');
      const eDay = endDate.getDate().toString().padStart(2, '0');
      this.formData[this.itemData] = [`${sYear}-${sMonth}-${sDay} 00:00:00`, `${eYear}-${eMonth}-${eDay} 23:59:59`];
    }
  }

  protected $$mounted() {
    super.$$mounted();
    this.mountedCallChaining?.hook(this.path, () => {
      this.mountedProcess();
    });
  }
}
